<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

definePageMeta({
  // title: 'register',
  layout: 'empty',
  middleware: ['auth'],
  requireLogin: false,
})
useHead({
  title: 'register',
})

const router = useRouter()
const toaster = useToaster()
const runtimeConfig = useRuntimeConfig()
</script>

<template>
  <div class="h-screen md:flex">
    <div
      class="from-primary-900 to-primary-500 i group relative hidden w-1/2 items-center justify-around overflow-hidden bg-gradient-to-tr md:flex"
    >
      <div class="mx-auto max-w-xs text-center">
        <BaseHeading as="h2" size="3xl" weight="medium" class="text-white mb-2">
          {{ $t('have_an_account') }}
        </BaseHeading>

        <BaseButton to="/login" rounded="md" color="info" class="w-full">{{
          $t('login_to_account')
        }}</BaseButton>
      </div>
      <div
        class="bg-muted-200/20 absolute -start-6 -top-6 h-14 w-0 origin-top-left rotate-45 rounded-full transition-all delay-[25ms] duration-300 group-hover:w-72"
      ></div>
      <div
        class="bg-muted-200/20 absolute -top-12 start-20 h-14 w-0 origin-top-left rotate-45 rounded-full transition-all delay-75 duration-300 group-hover:w-48"
      ></div>
      <div
        class="bg-muted-200/20 absolute -start-7 top-24 h-14 w-0 origin-top-left rotate-45 rounded-full transition-all delay-150 duration-300 group-hover:w-40"
      ></div>

      <div
        class="bg-muted-200/20 absolute -bottom-6 -end-6 h-14 w-0 origin-bottom-right rotate-45 rounded-full transition-all delay-150 duration-300 group-hover:w-72"
      ></div>
      <div
        class="bg-muted-200/20 absolute -bottom-12 end-20 h-14 w-0 origin-bottom-right rotate-45 rounded-full transition-all delay-75 duration-300 group-hover:w-48"
      ></div>
      <div
        class="bg-muted-200/20 absolute -end-7 bottom-24 h-14 w-0 origin-bottom-right rotate-45 rounded-full transition-all delay-[25ms] duration-300 group-hover:w-40"
      ></div>
    </div>
    <div
      class="flex flex-col items-center justify-between bg-white py-10 md:w-1/2 min-h-full"
    >
      <!-- <NuxtLink
        to="/"
        class="text-muted-400 hover:text-primary-500 transition-colors duration-300"
      >
        <GlobalLogo class="mx-auto h-auto w-[180px] lg:w-[250px] mb-4" />
      </NuxtLink> -->
      <div class="w-4/5">
        <BaseHeading as="h2" class="!text-xl lg:!text-2xl" weight="medium">
          {{ $t('welcome_back') }}
        </BaseHeading>
        <BaseParagraph class="!text-sm lg:!text-md text-muted-400 mb-6 mt-2">
          {{ $t('create_account') }}
        </BaseParagraph>
        <SignupForm />
      </div>

      <div class="text-center mt-3">
        <BaseText size="sm" class="text-muted-400">
          © {{ new Date().getFullYear() }}
          {{
            runtimeConfig.public.source == 'user'
              ? $t('gigcep')
              : $t('sosyal360')
          }}
          {{ $t('all_rights_reserved') }}.
        </BaseText>
      </div>
    </div>
  </div>
</template>
